<template>
    <div>
        <PageTitle :title="$t('renovar_abono.titulo', { temporada: lista_abonados.nombre, abono: teatro.texto_abono })" class="strech"/>
        <template v-if="! isLfp">
            <RenovarAbono />
        </template>
        <template v-else>
            <RenovarAbonoLfp/>
        </template>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import RenovarAbono from '@/components/frontend/abonos/renovar/RenovarAbono.vue';
    import RenovarAbonoLfp from '@/components/frontend/abonos/renovar/RenovarAbonoLfp.vue';

    export default {
        components: {
            PageTitle,
            RenovarAbono,
            RenovarAbonoLfp
        },
        head: {
            title: function() {
                return {
                    inner: 'Renovación de abonos',
                    complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
                }                         
            },
            meta: function() {
                return [
                    {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                    {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
                ]                
            },
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            isLfp() {
                return this.$store.getters.getFooter.lfp;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            }
        },
        created() {
            let super_iper_acceso = this.$route.query.super_iper_acceso

            if(!this.footer.renovar_abono && !(super_iper_acceso === "si")) {
                this.$router.push({ name: 'front.home'});
            }
        }
    }
</script>